import http from "./Http";

const getAll = async (params = {}) => {
    return http.get("/shipping-import-rules", { params });
};

const get = async (id) => {
    return http.get(`/shipping-import-rules/${id}`);
};

const post = async (body) => {
    return http.post("/shipping-import-rules", body);
};

const put = async (id, body) => {
    return http.put(`/shipping-import-rules/${id}`, body);
};

const del = async (id) => {
    return http.delete(`/shipping-import-rules/${id}`);
};

const ShippingImportRulesService = {
    getAll,
    get,
    post,
    put,
    del
};

export default ShippingImportRulesService;
